import DialogAbstract from '../abstract/DialogAbstract';
import { formatBackendError } from '../../utils/formatError';

export default class UpdateCommissionDialog extends DialogAbstract {
    // static DEFAULT_DATE_FROM = moment().startOf('day').format('YYYY-MM-DDT00:00:00');
    static DEFAULT_DATE_FROM = '2025-01-01T00:00:00'; s;
    static DEFAULT_DATE_TO = '2050-01-01T00:00:00';
    constructor(props) {
        super(props);
        this.Name = props.name;
        this.Head = props.Head;
        this.Server = props.server;
        this.onClose = props.onClose || (() => {});
        this.onSave = props.onSave || (() => {});
        this.state = {
            ...this.state,
            dialogOpen: props.dialogOpen || false,
            dialogData:
                {
                    ...props.dialogData,
                    dateFrom: UpdateCommissionDialog.DEFAULT_DATE_FROM,
                    dateTo: UpdateCommissionDialog.DEFAULT_DATE_TO
                } || {},
            initialData: { ...(props.dialogData || {}) },
            loading: false,
            alertError: null
        };
    }

    static getDerivedStateFromProps(props, state) {
        if (props.dialogOpen !== state.dialogOpen) {
            return {
                dialogOpen: props.dialogOpen,
                dialogData: {
                    ...props.dialogData,
                    dateFrom: UpdateCommissionDialog.DEFAULT_DATE_FROM,
                    dateTo: UpdateCommissionDialog.DEFAULT_DATE_TO
                },
                initialData: { ...props.dialogData },
                loading: false,
                alertError: null
            };
        }
        return null;
    }

    handleUpdateCurrentCommission = async (changeDate, id) => {
        const { initialData } = this.state;
        const updatedData = {
            ...initialData,
            dateTo: changeDate,
            dateFrom:
                initialData.dateFrom || UpdateCommissionDialog.DEFAULT_DATE_FROM
        };

        try {
            const result = await this.Server.update(id, updatedData);
            if (result?.error === 'OK') {
                console.log('Commission updated successfully:', result);
            } else {
                throw new Error(formatBackendError(result));
            }
        } catch (error) {
            this.setState({
                loading: false,
                alertError: formatBackendError(error)
            });
            throw error; // Re-throw to handle in the save handler
        }
    };

    handleCreateNewCommission = async () => {
        const { dialogData } = this.state;
        try {
            const result = await this.Server.add(dialogData);
            if (result?.error !== 'OK') {
                throw new Error(formatBackendError(result));
            }
        } catch (error) {
            this.setState({
                loading: false,
                alertError: formatBackendError(error)
            });
            throw error; // Re-throw to handle in the save handler
        }
    };

    handleDialogSave = async (event) => {
        const { dialogData } = this.state;
        const changeDate = dialogData.dateFrom;
        const id = dialogData.id;

        // Do not allow save if dimension/fee/min not changed from original
        // if (
        //     dialogData.dimension === initialData.dimension &&
        //     dialogData.fee === initialData.fee &&
        //     dialogData.minimalCommission === initialData.minimalCommission
        // ) {
        //     console.warn('No changes detected, skipping save.');
        //     this.onClose();
        //     return;
        // }

        this.setState({ loading: true, alertError: null });

        try {
            await this.handleUpdateCurrentCommission(changeDate, id);
            await this.handleCreateNewCommission();
            this.onSave(dialogData);
            this.onClose();
        } catch (error) {
            this.setState({ alertError: formatBackendError(error) });
        } finally {
            this.setState({ loading: false });
        }
    };
}
